/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { sectorActions } from '../_actions'
import PreviewComponent from '../components/PreviewComponent'
import { getLoader } from '../_common/utils'

function PreviewContainer({ isLoading, chartData, getSectorChartData,
  getCompanyBySectorIndustyChartData, linkChartData, selectedChartNode,
  industryChartData, selectedCompanyNode, linkCompanyData, selectedCompany }) {

  useEffect(() => {
    const chartDiv = document.getElementById('chart')
    if (chartDiv)
      chartDiv.innerHTML = ''
    getSectorChartData()
  }, [getSectorChartData])
  return (<div className="pageWrapper p-col-12">
    {isLoading ? getLoader() : ''}<PreviewComponent
      linkChartData={linkChartData}
      chartData={chartData}
      selectedChartNode={selectedChartNode}
      industryChartData={industryChartData}
      getCompanyBySectorIndustyChartData={getCompanyBySectorIndustyChartData}
      selectedCompanyNode={selectedCompanyNode}
      linkCompanyData={linkCompanyData}
      selectedCompany={selectedCompany}
    /></div>)
}
PreviewContainer.propTypes = {
  chartData: PropTypes.object,
  getSectorChartData: PropTypes.func,
  isLoading: PropTypes.bool,
  getCompanyBySectorIndustyChartData: PropTypes.func,
  linkChartData: PropTypes.func,
  selectedChartNode: PropTypes.object,
  industryChartData: PropTypes.object,
  selectedCompanyNode: PropTypes.object,
  linkCompanyData: PropTypes.func,
  selectedCompany: PropTypes.object
}
const mapStateToProps = state => {
  return {
    chartData: state.sector.chartData,
    chartDataMessage: state.sector.chartDataMessage,
    isLoading: state.sector.loading,
    selectedChartNode: state.sector.chartNode,
    industryChartData: state.sector.industryChartData,
    selectedCompanyNode: state.sector.selectedCompanyNode,
    selectedCompany: state.sector.selectedCompany
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getSectorChartData: () => dispatch(sectorActions.getSectorChartData()),
    getCompanyBySectorIndustyChartData: (sectorId, industryId) => dispatch(sectorActions.getCompanyBySectorIndustyChartData(sectorId, industryId)),
    linkChartData: (node) => dispatch(sectorActions.linkChartData(node)),
    linkCompanyData: (node) => dispatch(sectorActions.linkCompanyData(node))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviewContainer)
